import styled from 'styled-components'

interface BoardProps {
  isCode: boolean
}

export const Container = styled.div`
  min-height: 70vh;
  overflow: auto;
`

export const Boards = styled.div`
  display: flex;
  gap: 1rem;
  padding-bottom: 1rem;

  .teste {
    width: 100%;
  }

  .title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0.8rem 1rem;
    border: 1px solid #ebebeb;
    border-radius: 0.6rem;

    position: sticky;
    top: 0;
    z-index: 100;
  }
`

export const Wrapper = styled.div``

export const Board = styled.div<BoardProps>`
  min-width: ${(props) => (props.isCode ? '180px' : '350px')};
  margin-top: 0.8rem;

  padding-right: 0.8rem;
  padding-bottom: 1rem;

  .cards {
    display: flex;
    align-items: flex-start;
    flex-direction: column;
    gap: 0.4rem;
  }
`
